import { useState } from 'react'

export function useRequestProfileTabEmailsSearchResult({
  isSearchActive,
  items,
}) {
  const [shownResult, setShownResult] = useState({ isSearchActive, items })

  // Tied to the shown items, not to the term that is still reloading them.
  if (shownResult.items !== items) {
    setShownResult({ isSearchActive, items })
  }

  return { isSearchResult: shownResult.isSearchActive }
}
